"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBReformRentPositive = function SvgBReformRentPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M22.323 132.541a5.378 5.378 0 01-5.299-5.352L16.89 74.76c0-.388-.156-.76-.434-1.03a1.391 1.391 0 00-1.03-.429l-11.202.034a3.61 3.61 0 01-2.55-6.167c9.912-9.804 28.194-27.985 44.606-44.285L67.675 1.647a5.74 5.74 0 018.098.023l49.641 49.91a2.087 2.087 0 11-2.96 2.94L72.822 4.61a1.572 1.572 0 00-2.205-.038L49.24 25.843A97951.903 97951.903 0 015.632 69.16l9.804-.031a5.642 5.642 0 015.655 5.623l.108 52.427a1.217 1.217 0 001.197 1.19l39.479-.104a1.28 1.28 0 001.275-1.279l-.021-6.373a8.591 8.591 0 016.477-8.355l-.06-21.312a2.087 2.087 0 114.175-.01l.062 23.149a2.087 2.087 0 01-2.082 2.092 4.397 4.397 0 00-4.397 4.425l.02 6.367a5.44 5.44 0 01-5.431 5.47l-39.487.112-.083-.009z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M48.5 106.135a2.087 2.087 0 01-1.834-2.982l23.263-49.271a2.088 2.088 0 013.778.003l23.222 49.15a2.087 2.087 0 01-1.881 2.973l-9.741.025a2.087 2.087 0 01-.011-4.175l6.422-.02-19.9-42.176-19.983 42.287 18.564-.045.042.001a2.087 2.087 0 11-.031 4.174l-21.87.057-.04-.001z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M28.782 65.826a2.087 2.087 0 01-1.44-3.56l41.457-41.675a3.897 3.897 0 012.803-1.162 3.94 3.94 0 012.763 1.148l40.527 40.296a2.089 2.089 0 01-2.946 2.961l-40.35-40.126-41.3 41.505c-.4.401-.947.623-1.514.613zM75.092 132.398a2.087 2.087 0 01.031-4.174l45.999-.123c.316.004.62-.121.84-.347.227-.224.352-.53.35-.85l-.048-13.22a2.087 2.087 0 114.175-.01l.047 13.22a5.37 5.37 0 01-5.354 5.382l-45.998.123-.042-.001z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M107.929 115.417a2.087 2.087 0 01-2.051-2.081l-.116-43.57a2.087 2.087 0 01.61-1.479l16.352-16.413a2.089 2.089 0 012.96 2.946l-15.742 15.832.105 40.6 28.625-.078-.112-40.6-8.131-8.122a2.087 2.087 0 012.946-2.947l8.747 8.696c.389.395.61.925.614 1.48l.116 43.563a2.087 2.087 0 01-2.082 2.092l-32.8.089-.041-.008z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M124.291 103.576a2.087 2.087 0 01-2.05-2.082l-.055-16.407a2.087 2.087 0 114.174-.01l.055 16.4a2.087 2.087 0 01-2.082 2.1l-.042-.001z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M124.116 86.478a8.96 8.96 0 11.174.003l-.174-.003zm.231-13.216l-.09-.001a4.515 4.515 0 00-3.169 7.716 4.522 4.522 0 006.38-.02 4.508 4.508 0 00-3.12-7.709v.014zM117.723 105.966a2.087 2.087 0 01-2.05-2.082l-.006-3.298a2.087 2.087 0 01.603-1.478 2.087 2.087 0 011.48-.614l6.567-.018a2.087 2.087 0 012.093 2.082l.012 3.298a2.087 2.087 0 01-2.082 2.093l-6.575.017h-.042z",
    fill: "#285"
  })));
};

var _default = SvgBReformRentPositive;
exports["default"] = _default;